/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useContext, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { debounce } from "../../../../../utils/helper";
import { AlertStatus } from "../../../../../contants";
import Modal from "../../../../../components/common/Modal/Modal";
import InputField from "../../../../../components/common/new/InputField/InputField";
import { CommonStyles } from "../../../../../components/common/Button/commonButtonStyle";
import Button from "../../../../../components/common/Button";
import Styles from "./styles";
import { ToastAlertContext } from "../../../../../config/providers/ToastAlert";
import Member from "../../../../../services/api/member";

const AWARDS_SUBMISSION = {
  AWARD_NAME: "awardName",
  AWARD_FOR: "awardFor",
  AWARD_DATE: "awardDate",
  MEMBER_ID: "memberId",
};

function AwardsModal({ open, onClose, application, onRefresh }) {
  // eslint-disable-next-line no-unused-vars
  const [applicationDate, setApplicationDate] = useState(null);

  const toast = useContext(ToastAlertContext);

  const submitReviewRequest = async (values) => {
    try {
      await Member.CreateAward({ ...values }, application?.memberId);

      toast.show(`Award Created Successfully`, AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
        onClose();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <Formik
          initialValues={{ [AWARDS_SUBMISSION.AWARD_DATE]: null }}
          enableReinitialize
          onSubmit={debounce(submitReviewRequest)}
        >
          {({ handleChange, values, handleSubmit, errors, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: "20px ",
                    fontWeight: "500",
                  }}
                >
                  Awards
                </Typography>
                <Box marginTop="10px" color="#183053">
                  <Typography />
                  <Typography variant="small" weight={500} color="#183053">
                    {/* {Object?.values(userOSNames)?.join("/")} */}
                    {[
                      application?.areaName,
                      application?.zoneName,
                      application?.regionName,
                      application?.chapterName,
                      application?.districtName,
                      application?.blockName,
                    ]
                      .filter(Boolean)
                      .join("/ ")}
                  </Typography>
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                  }}
                >
                  <Grid item md={8} sm={12}>
                    <div style={{ padding: "20px 0px 0px 10px" }}>
                      <div style={{ ...Styles.gridContainer }}>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Member Id"
                            name={AWARDS_SUBMISSION.MEMBER_ID}
                            // value={values[AWARDS_SUBMISSION.MEMBER_ID]}
                            value={application?.memberId}
                            error={errors[AWARDS_SUBMISSION.MEMBER_ID]}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Award Name"
                            name={AWARDS_SUBMISSION.AWARD_NAME}
                            value={values[AWARDS_SUBMISSION.AWARD_NAME]}
                            error={errors[AWARDS_SUBMISSION.AWARD_NAME]}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Award For"
                            name={AWARDS_SUBMISSION.AWARD_FOR}
                            value={values[AWARDS_SUBMISSION.AWARD_FOR]}
                            error={errors[AWARDS_SUBMISSION.AWARD_FOR]}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={AWARDS_SUBMISSION.AWARD_DATE}
                              label="Award Date"
                              inputFormat="DD/MM/YYYY"
                              maxDate={new Date()}
                              value={values?.[AWARDS_SUBMISSION.AWARD_DATE]}
                              onChange={(newValues) => {
                                setFieldValue(
                                  [AWARDS_SUBMISSION.AWARD_DATE],
                                  dayjs(newValues).format("YYYY-MM-DD")
                                );
                                setApplicationDate(
                                  new Date(
                                    new Date(newValues).getTime() +
                                      24 * 60 * 60 * 1000
                                  )
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    padding: "10px 0px 0px 10px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={CommonStyles.buttonStyle}
                    type="submit"
                    label="Submit"
                  />
                  <Button
                    variant="outlined"
                    style={{
                      ...CommonStyles.buttonStyle,
                      marginLeft: "20px",
                    }}
                    onClick={onClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default AwardsModal;
